module.exports = __webpack_public_path__ + "media/images/banner04b-413a3eefc66839a5f08afc33df71b8e5.webp";